import { Card, CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { jobTypeOptions } from "@src/appV2/redesign/PlacementCandidate/constants";
import { type JobType } from "@src/appV2/redesign/PlacementCandidate/types";
import pluralize from "pluralize";

interface NoYearsOfExperiencePayDataAlertProps {
  jobType: JobType;
  lowestMinYearsOfExperience: number;
}

export function NoYearsOfExperiencePayDataAlert(props: NoYearsOfExperiencePayDataAlertProps) {
  const { jobType, lowestMinYearsOfExperience } = props;

  const jobTypeLabel = jobTypeOptions.find((option) => option.value === jobType)?.label;

  if (!jobTypeLabel || lowestMinYearsOfExperience === 0) {
    return null;
  }

  const yearsLabel = pluralize("year", lowestMinYearsOfExperience);
  const minYearsOfExperienceLabel = `${lowestMinYearsOfExperience} ${yearsLabel} of experience`;

  return (
    <Card sx={{ backgroundColor: (theme) => theme.palette.intent?.warning.background, p: 5 }}>
      <Stack direction="row" spacing={3}>
        <CbhIcon
          type="triangle-exclamation"
          size="small"
          sx={{ color: (theme) => theme.palette.intent?.warning.icon }}
        />
        <Text variant="body2" color={(theme) => theme.palette.intent?.warning.text}>
          {`${jobTypeLabel} requires a minimum of ${minYearsOfExperienceLabel}. Showing pay rates for ${minYearsOfExperienceLabel}.`}
        </Text>
      </Stack>
    </Card>
  );
}
